'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "Why is social media marketing important for my business?",
    answer: "Social media marketing helps you connect directly with your audience, build brand awareness, drive traffic, and generate leads. It’s essential for creating a strong online presence and staying competitive in today’s digital landscape."
  },
  {
    question: "Which platforms should my business be on?",
    answer: "It depends on your target audience. We analyze your industry and goals to recommend the best platforms — like Facebook, Instagram, LinkedIn, Twitter, or TikTok — and tailor strategies accordingly for maximum engagement."
  },
  {
    question: "What kind of content will you create for my social media?",
    answer: "We create engaging content including posts, reels, stories, infographics, carousels, and videos — all aligned with your brand voice and marketing objectives. Our content strategy focuses on consistency, quality, and results."
  },
  {
    question: "How do you measure the success of social media campaigns?",
    answer: "We track key metrics like reach, engagement, follower growth, website clicks, and conversions. You’ll receive regular performance reports so you can see what’s working and where we’re optimizing."
  },
  {
    question: "Can you also manage ads and influencer collaborations?",
    answer: "Yes. We handle everything from social media ad campaigns to influencer partnerships. Whether you want to boost posts, run targeted ads, or collaborate with relevant creators, we’ve got you covered."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div
        className="col text-center py-5 mt-5"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="500"
        data-aos-once="true"
      >
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
